// import React, { useEffect, useState } from "react";
// import { IoCloseOutline } from "react-icons/io5";
// import { useDispatch, useSelector } from "react-redux";
// import { closeModal } from "../../../features/modal/ModalSlice";
// import { Box, Divider, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
// import CustomButton from "../../Button/CustomButton";
// import apiClient from "../../../services/apiClient";
// import toast from "react-hot-toast";

// const ConfigureNumberAllocation = () => {
//   const [formCount] = useState(1);
//   const [formData, setFormData] = useState([{ extension: "", user: "" }]);
//   const [extension, setExtensions] = useState([]);
//   const [team, setTeam] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const modal = useSelector((state) => state?.modal?.modal);
//   const userInfo = useSelector((state) => state?.userInfo?.user);

//   useEffect(() => {
//     // handleFormCountChange(extension?.length);
//     fetchRequests();
//     fetchTeamMember();
//   }, []);

//   const fetchTeamMember = async () => {
//     console.log(modal?.data);
//     try {
//       if (!modal?.data) {
//         const response = await apiClient.get(`/UsersByCompany/${userInfo?.company_id}`);
//         setTeam(response?.data?.users || []);
//       } else setTeam([modal?.data]);
//     } catch (error) {
//       console.error("Error fetching users by company:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchRequests = async () => {
//     try {
//       const response = await apiClient.get(
//         `/assignedPhoneDetails?user_id=${userInfo?.id}&company_id=${
//           userInfo?.company_id
//         }&assigned_phone_status=${"not-assigned"}`
//       );
//       setExtensions(response?.data || []);

//       console.log(response);
//       // setTeam(response?.data?.company_data?.users);
//     } catch (error) {
//       console.error("Error fetching users by company:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // const handleFormCountChange = (count) => {
//   //   if (count > 0) {
//   //     setFormCount(count);
//   //     const updatedFormData = [...formData];
//   //     // Ensure formData has entries for all forms
//   //     while (updatedFormData.length < count) {
//   //       updatedFormData.push({ extension: "", user: "" });
//   //     }
//   //     // Slice extra forms if reducing form count
//   //     setFormData(updatedFormData.slice(0, count));
//   //   }
//   // };

//   const handleFieldChange = (index, field, value) => {
//     const updatedFormData = [...formData];
//     updatedFormData[index] = { ...updatedFormData[index], [field]: value };
//     setFormData(updatedFormData);
//   };

//   // const getAvailableOptions = (field) => {
//   //   const selectedValues = formData.map((form) => form[field]);
//   //   return field === "extension"
//   //     ? allExtensions.filter((ext) => !selectedValues.includes(ext))
//   //     : allUsers.filter((user) => !selectedValues.includes(user));
//   // };

//   const dispatch = useDispatch();

//   const handleClosePopup = () => {
//     dispatch(closeModal());
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     // console.log(
//     //   formData.map((item) => {
//     //     return {
//     //       user_id: item?.user._id,
//     //       username: item?.extension.username,
//     //       password: item?.extension.password,
//     //       effective_caller_id_number: item?.extension.effective_caller_id_number,
//     //     };
//     //   })
//     // );
//     console.log(
//       formData.map((item) => {
//         return {
//           user_id: item.user._id,
//           user_name: item.user.name,
//           username: item.extension.username,
//           password: item.extension.password,
//           effective_caller_id_number: item.extension.effective_caller_id_number,
//         };
//       })
//     );

//     // return;

//     setLoading(true);
//     try {
//       // const payload = {
//       //   owner_id: userInfo?.id,
//       //   company_id: userInfo?.company_id,
//       //   user_id: formData[0]?.user._id,
//       //   username: formData[0]?.extension.username,
//       //   password: formData[0]?.extension.password,
//       //   caller_id: formData[0]?.extension.effective_caller_id_number,
//       //   credentials: formData[0]?.extension,
//       // };
//       // await apiClient.post("/allocatedExtensions", payload);

//       const payload = {
//         owner_id: userInfo?.id,
//         company_id: userInfo?.company_id,
//         user_id: formData[0]?.user._id,
//         extension_id: formData?.extension?._id,
//         username: formData[0]?.extension.username,
//         password: formData[0]?.extension.password,
//         caller_id: formData[0]?.extension.effective_caller_id_number,
//         credentials: formData[0]?.extension,
//       };
//       await apiClient.post("/allocatedExtensions", payload);

//       toast.success("Extensions Assigned!");
//       handleClosePopup();
//     } catch (err) {
//       console.log(err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className={"rightModal taskModal"}>
//       <div className="modal-header p-3">
//         <h4 className="m-0">Configure Number</h4>
//         <button className="btnClose ms-auto" onClick={handleClosePopup}>
//           <IoCloseOutline />
//         </button>
//       </div>

//       <div className="p-4">
//         <Box component="form" onSubmit={handleSubmit}>
//           {[...Array(formCount)].map((_, index) => (
//             <Box className="my-2">
//               <FormControl fullWidth margin="normal">
//                 <InputLabel id={`extension-label-${index}`} size="small">
//                   Extension
//                 </InputLabel>
//                 <Select
//                   labelId={`extension-label-${index}`}
//                   label={"Extension"}
//                   id={`extension-${index}`}
//                   size="small"
//                   value={formData[index].extension}
//                   onChange={(e) => handleFieldChange(index, "extension", e.target.value)}
//                 >
//                   {/* <MenuItem value="">
//                     <em>Select Extension</em>
//                   </MenuItem> */}
//                   {extension?.map((ext, index) => (
//                     <MenuItem key={index} value={ext?.data}>
//                       {ext?.data?.username} ({ext?.data?.effective_caller_id_number})
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>

//               <FormControl fullWidth margin="normal">
//                 <InputLabel id={`user-label-${index}`} size="small">
//                   User
//                 </InputLabel>
//                 <Select
//                   labelId={`user-label-${index}`}
//                   label={"User"}
//                   id={`user-${index}`}
//                   size="small"
//                   value={formData[index].user}
//                   onChange={(e) => handleFieldChange(index, "user", e.target.value)}
//                 >
//                   {/* <MenuItem value="">
//                     <em>Select User</em>
//                   </MenuItem> */}
//                   {team.map((user, index) => (
//                     <MenuItem key={index} value={user}>
//                       {user?.name}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>

//               <Divider />
//             </Box>
//           ))}

//           <div className="d-flex justify-content-end gap-3 mb-4">
//             <CustomButton
//               type="submit"
//               variant="contained"
//               color="secondary"
//               onClick={handleClosePopup}
//             >
//               Cancel
//             </CustomButton>
//             <CustomButton type="submit" variant="contained" color="primary" loading={loading}>
//               Submit
//             </CustomButton>
//           </div>
//         </Box>
//       </div>
//     </div>
//   );
// };

// export default ConfigureNumberAllocation;

import React, { useEffect, useState } from "react";
import { IoCloseOutline } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { closeModal, closeModalWithUpdate } from "../../../features/modal/ModalSlice";
import { Box, Divider, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import CustomButton from "../../Button/CustomButton";
import apiClient from "../../../services/apiClient";
import toast from "react-hot-toast";

const ConfigureNumberAllocation = () => {
  const [formData, setFormData] = useState({ extension: "", user: "" });
  const [extensions, setExtensions] = useState([]);
  const [team, setTeam] = useState([]);
  const [loading, setLoading] = useState(false);

  const modal = useSelector((state) => state?.modal?.modal);
  const userInfo = useSelector((state) => state?.userInfo?.user);

  const dispatch = useDispatch();

  useEffect(() => {
    fetchExtensions();
    fetchTeamMembers();
  }, []);

  const fetchTeamMembers = async () => {
    // console.log(modal?.data);
    try {
      if (!modal?.data) {
        const response = await apiClient.get(`/UsersByCompany/${userInfo?.company_id}`);
        setTeam(response?.data?.users || []);
      } else setTeam([modal?.data]);
    } catch (error) {
      console.error("Error fetching users by company:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchExtensions = async () => {
    try {
      const response = await apiClient.get(
        `/assignedPhoneDetails?owner_id=${userInfo?.id}&company_id=${userInfo?.company_id}&assigned_phone_status=not-assigned&page=1&page_size=100`
      );
      setExtensions(response?.data || []);
    } catch (error) {
      console.error("Error fetching extensions:", error);
    }
  };

  const handleFieldChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleClosePopup = () => {
    dispatch(closeModal());
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);

    try {
      const payload = {
        user_id: formData?.user?._id,
        assigned_phone_status: "assigned",
      };
      await apiClient.put(`/assignedPhoneDetails-update/${formData?.extension?._id}`, payload);

      toast.success("Extension Assigned!");
      dispatch(
        closeModalWithUpdate({
          isUpdated: {
            isUpdatedIn: "TEAMS",
            data: null,
          },
        })
      );
    } catch (error) {
      console.error("Error assigning extension:", error);
      toast.error("Oops! An error occurred Please try again!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="rightModal taskModal">
      <div className="modal-header p-3">
        <h4 className="m-0">Configure Number</h4>
        <button className="btnClose ms-auto" onClick={handleClosePopup}>
          <IoCloseOutline />
        </button>
      </div>

      <div className="p-4">
        <Box component="form" onSubmit={handleSubmit}>
          <FormControl fullWidth margin="normal">
            <InputLabel id="extension-label" size="small">
              Extension
            </InputLabel>
            <Select
              labelId="extension-label"
              label="Extension"
              id="extension"
              size="small"
              value={formData.extension}
              onChange={(e) => handleFieldChange("extension", e.target.value)}
              required
            >
              {extensions?.map((ext, index) => (
                <MenuItem key={index} value={ext}>
                  {ext?.data?.username} ({ext?.data?.effective_caller_id_number})
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl fullWidth margin="normal">
            <InputLabel id="user-label" size="small">
              User
            </InputLabel>
            <Select
              labelId="user-label"
              label="User"
              id="user"
              size="small"
              value={formData.user}
              onChange={(e) => handleFieldChange("user", e.target.value)}
              required
            >
              {team.map((user, index) => (
                <MenuItem key={index} value={user}>
                  {user?.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Divider />

          <div className="d-flex justify-content-end gap-3 mb-4">
            <CustomButton
              type="button"
              variant="contained"
              color="secondary"
              onClick={handleClosePopup}
            >
              Cancel
            </CustomButton>
            <CustomButton type="submit" variant="contained" color="primary" loading={loading}>
              Submit
            </CustomButton>
          </div>
        </Box>
      </div>
    </div>
  );
};

export default ConfigureNumberAllocation;
